import { Trans, useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { LOAN_GROUPS } from '@/helpers/constants';
import { useAllocationStatus } from '@/pages/InvestingPage/hooks/useAllocationStatus';
import { TableView } from './table';
import s from './index.module.scss';

export const RepaymentSchedule = ({ data }) => {
  const { t } = useTranslation();
  const { allocatedGroupA, allocatedGroupB } = useAllocationStatus();

  const LOAN_GROUPS_T = LOAN_GROUPS(t);

  const getGroup = () => {
    if (allocatedGroupA && allocatedGroupB) {
      return `${LOAN_GROUPS_T.conservative.full_name} and ${LOAN_GROUPS_T.moderate.full_name}`;
    }
    if (allocatedGroupA) {
      return LOAN_GROUPS_T.conservative.full_name;
    }
    if (allocatedGroupB) {
      return LOAN_GROUPS_T.moderate.full_name;
    }
  };

  const groups = getGroup();

  if (!data) {
    return null;
  }

  return (
    <div className={s.wrapper}>
      <div className={s.note}>
        {t('investing:repayment_schedule.may_be_changed')}
      </div>
      <div className={s.schedule}>
        <div className={s.note}>
          {t('investing:repayment_schedule.loan', { groups })}
        </div>
        <TableView data={data} />
        <div className={s.hint}>
          <Trans
            ns="investing"
            i18nKey="repayment_schedule.is_subject_to_changes"
            components={{
              Span: <span className="f-600" />,
              HelpLink: (
                <MyLink
                  href={APP_LINKS.helpLoanTerms()}
                  className="f-600"
                  underline
                />
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};
